import { connect } from "react-redux"
import React, { Component } from 'react';
import './Common.css';
import './AuthenticationStatus.css';
import { showAuthStatus }  from '../actions/betActions';

const stateMap = (store) => {
    return {
        showAuthStatus: store.bet.showAuthStatus,
        authentication: store.bet.authentication,
        monitorBetIds: store.bet.monitorBetIds,
        monitorTxHashes: store.bet.monitorTxHashes,
        blockchainDataMap: store.bet.blockchainDataMap,
        pageContext: store.bet.pageContext,
        selectedPage: store.bet.selectedPage,
        loggedIn: store.bet.authentication.loggedIn,
        pageLoaded: store.bet.pageLoaded
    };
};
class AuthenticationStatus extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.handleClick = this.handleClick.bind(this);
        this.toggleShow = this.toggleShow.bind(this);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    handleClick(event) {
    }

    toggleShow(event) {
        this.props.dispatch(showAuthStatus(!this.props.showAuthStatus));
    }

    render() {

        let { blockchainDataMap } = this.props;

        let blockchainDataIdList = [];
        for(let betId in blockchainDataMap) {
            blockchainDataIdList.push(betId);
        }

        let keyUsername = "";
        let keyProposal = "";
        let keyVersion = "";
        let keyCombined = "";
        let selectedBetId = "";
        let contextPath = this.props.selectedPage+"_CONTEXT";

        let pendingLoadProposalData = false;
        if(contextPath in this.props.pageContext) {
            let context = this.props.pageContext[contextPath];
            if("betId" in context) {
                selectedBetId = context.betId;
            }

            if("keyUsername" in context && "keyProposal" in context  && "keyVersion" in context) {
                keyUsername = context.keyUsername;
                keyProposal = context.keyProposal;
                keyVersion = context.keyVersion;
                keyCombined = keyUsername + "/" + keyProposal + "/" + keyVersion;
            }

            if("pendingLoadProposalData" in context) {
                pendingLoadProposalData = context.pendingLoadProposalData;
            }
        }

        let txHashes = [];
        for(let i=0; i<this.props.monitorTxHashes.length; i++) {
            txHashes.push(this.props.monitorTxHashes[i].txHash);
        }

        if(this.props.showAuthStatus) {
            return (
                <div className="authStatusWindow" onClick={this.toggleShow}>
                    <table><tbody>
                        <tr><td className="authStatusLabel">Has Metamask</td><td className="authStatusValue">{this.props.authentication.hasMetamask.toString()}</td></tr>
                        <tr><td className="authStatusLabel">Address</td><td className="authStatusValue">{this.props.authentication.ethAccount}</td></tr>
                        <tr><td className="authStatusLabel">Network</td><td className="authStatusValue">{this.props.authentication.network}</td></tr>
                        <tr><td className="authStatusLabel">UUID</td><td className="authStatusValue">{this.props.authentication.uuid}</td></tr>
                        <tr><td className="authStatusLabel">Username</td><td className="authStatusValue">{this.props.authentication.username}</td></tr>
                        <tr><td className="authStatusLabel">Authenticated</td><td className="authStatusValue">{this.props.authentication.hasDatabaseAuth.toString()}</td></tr>
                        <tr><td className="authStatusLabel">Two way exists</td><td className="authStatusValue">{this.props.authentication.twoWayExists.toString()}</td></tr>
                        <tr><td className="authStatusLabel">Tweet ID</td><td className="authStatusValue">{this.props.authentication.tweetId}</td></tr>
                        <tr><td className="authStatusLabel">Monitoring txHashes</td><td className="authStatusValue">{JSON.stringify(txHashes)}</td></tr>
                        <tr><td className="authStatusLabel">Monitoring bet IDs</td><td className="authStatusValue">{JSON.stringify(this.props.monitorBetIds)}</td></tr>
                        <tr><td className="authStatusLabel">Loaded bet IDs</td><td className="authStatusValue">{JSON.stringify(blockchainDataIdList)}</td></tr>
                        <tr><td className="authStatusLabel">Selected page</td><td className="authStatusValue">{this.props.selectedPage}</td></tr>
                        <tr><td className="authStatusLabel">Bet DB key</td><td className="authStatusValue">{keyCombined}</td></tr>
                        <tr><td className="authStatusLabel">Blockchain bet Id</td><td className="authStatusValue">{selectedBetId}</td></tr>
                        <tr><td className="authStatusLabel">Logged in</td><td className="authStatusValue">{this.props.loggedIn.toString()}</td></tr>
                        <tr><td className="authStatusLabel">Page loaded</td><td className="authStatusValue">{this.props.pageLoaded.toString()}</td></tr>
                        <tr><td className="authStatusLabel">Pending data</td><td className="authStatusValue">{pendingLoadProposalData.toString()}</td></tr>
                    </tbody></table>
                </div>
            );
        }
        else {
            return (
                <div className="authStatusTeaser" onClick={this.toggleShow}>
                </div>
            );
        }

    }
}
  
export default connect(stateMap)(AuthenticationStatus);


// WEBPACK FOOTER //
// ./src/components/AuthenticationStatus.js